import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Camera, Loader2, Trash2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AvatarUploadButton = ({ userId, hasPhoto, onChange, compact = false }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const base = userId ? `${API}/users/${userId}/avatar` : `${API}/users/me/avatar`;
  const key = userId || 'me';

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 3 * 1024 * 1024) {
      toast.error('Photo trop volumineuse (3 Mo maximum)');
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await axios.post(base, fd);
      onChange?.(data.avatar_url);
      toast.success('Photo mise à jour');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Envoi de la photo impossible');
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = '';
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await axios.delete(base);
      onChange?.(null);
      toast.success('Photo retirée');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Suppression impossible');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`avatar-input-${key}`} />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`avatar-upload-btn-${key}`} title="Changer la photo">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}
        {!compact && <span className="ml-2">Changer la photo</span>}
      </Button>
      {hasPhoto && (
        <Button type="button" variant="ghost" size="sm" disabled={busy} onClick={remove} data-testid={`avatar-remove-btn-${key}`} title="Retirer la photo">
          <Trash2 className="w-4 h-4 text-red-600" />
        </Button>
      )}
    </div>
  );
};

export default AvatarUploadButton;
